import { render, staticRenderFns } from "./NewSingleCapLog.vue?vue&type=template&id=0890d944&"
import script from "./NewSingleCapLog.vue?vue&type=script&lang=js&"
export * from "./NewSingleCapLog.vue?vue&type=script&lang=js&"
import style0 from "./NewSingleCapLog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/idev/ui_projects/vue/training/topnav-auth-skeleton-1/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle})
